export const projectData = [
  {
    name: `Notion Clone`,
    description: `Notion is the connected workspace where better, faster work happen. A produciton grade application with tests coverage. (Fullstack)`,
    demo: "https://notionclone-58a4fbf9c469.herokuapp.com/",
    github: "https://github.com/juneidea/Notion-Clone",
    tech: ["Django", "JWT", "Oauth", "NextJS", "Tailwind"],
    image: "notionClone.png",
    active: true,
  },

  {
    name: `Tick-Toc`,
    description: `Reverse engineered of the popular collaborative game keep talking & nobody explodes on a website 3D graphic. Try it out! (Fullstack)`,
    demo: "http://ec2-3-133-84-229.us-east-2.compute.amazonaws.com",
    github: "https://github.com/juneidea/tick-toc-resurrect",
    tech: ["Node", "React", "Postgres", "Docker", "AWS"],
    image: "tickToc.png",
    active: true,
  },

  {
    name: `Candy-Shop`,
    description: `While candy pretty much sells itself, an E-commerce web can be a place for catching those craving consumers (Fullstack)`,
    demo: "http://ec2-52-14-96-211.us-east-2.compute.amazonaws.com/",
    github: "https://github.com/juneidea/candy-shop",
    tech: ["Typescript", "Postgres", "Docker", "AWS"],
    image: "candyShop.png",
    active: true,
  },

  {
    name: `Chart&Form`,
    description: `2 sorted charts with a form to add more bars. Input form with warning error messages when off focus.`,
    demo: "https://juneidea-portfolio.herokuapp.com/bar-chart",
    github: "https://github.com/juneidea/bar-chart",
    tech: ["React", "chart", "form control"],
    image: "chart.png",
    active: true,
  },

  {
    name: `Three-Journey`,
    description: `A stackathon award winner - A presentative website about Three.js and its 3D features through my little projects and experiments`,
    demo: "https://juneidea.github.io/three-journey/",
    github: "https://github.com/juneidea/three-journey",
    tech: ["Three.js", "CSS", "HTML"],
    image: "threeJ.png",
    active: true,
  },

  {
    name: `Cold Stack`,
    description: `An alumni page for Fullstack Chicago. Student photo album that flow with flip effect and link to their profile linkedin`,
    demo: "https://juneidea.github.io/ColdStack/",
    github: "https://github.com/juneidea/ColdStack",
    tech: ["JavaScript", "CSS", "HTML"],
    image: "coldStack.png",
    active: true,
  },

  {
    name: `Guessing Game`,
    description: `Intro project at Fullstack Academy to teach DOM manipulation, events, and object-oriented programming. I added hints, CSS gradient.`,
    demo: "https://juneidea.github.io/Guessing-Game/",
    github: "https://github.com/juneidea/Guessing-Game",
    tech: ["JavaScript", "CSS", "HTML"],
    image: "guessing.png",
    active: true,
  },
];
